import type { LandingMarketsResponse } from '@/app/api/landing/markets/types'
import { useQuery } from '@tanstack/react-query'

async function fetchLandingMarkets(): Promise<LandingMarketsResponse> {
  const res = await fetch('/api/landing/markets')
  if (!res.ok) throw new Error(`Landing markets fetch failed: ${res.status}`)
  return res.json()
}

export function useLandingMarkets() {
  return useQuery({
    queryKey: ['landing-markets'],
    queryFn: fetchLandingMarkets,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
  })
}
